import envVars from '../../../constants/envVars';
const base = envVars.API_NOTIFICATION_HOSTNAME.replace(/\/+$/, '');
// An unset hostname would yield a relative URL that the backoffice itself answers with 200 HTML.
const markUrl = (path) => {
    if (!base)
        throw new Error('REACT_APP_API_NOTIFICATION_HOSTNAME is not configured');
    return `${base}/api/v1/mark/${path}`;
};
export default markUrl;
